import {gql} from 'apollo-boost';

export const GET_VDOLIVESET = gql`
  query getVdoLiveSet($id : ID!){
    getVdoLiveSet (
      id: $id
    ) {
      id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      liveClassSchedule{
        id periodCode degreeCode subjectGroupCode subjectCode subjectName
        teacherCode teacherFullName sectionNo topicLocal topicEng
        dateTimeFrom dateTimeTo liveFrom contract remark
        rtmpServer rtmpStream isEnabled
        academicPeriod { id periodCode }
        degree { id code nameLocal nameEng }
        subjectGroup { id code nameLocal nameEng }
        subject { id code nameLocal nameEng }
        teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
          telephone email socialMedia availableTime isSpecialTeacher picturePath label
        }
        courseOutlineRegistration  { id }
        classSection { id sectionNo descriptionLocal descriptionEng
          startClassDate learnSpanNo examSpanNo studentRegisterQty
          classRoom{
            id
            nameLocal
            nameEng
            studentRegisterQty
            capacity
            startDate
            endDate
            courseOutlineRegistration{
              id
              courseOutline {
                id courseOutlineUnits{
                  id seq nameLocal nameEng
                }
              }
            }
            degree{ id code }
            subjectGroup{ id code}
            classSection{
              id sectionNo descriptionLocal descriptionEng startClassDate
              learnSpanNo examSpanNo studentQty studentRegisterQty
            }
            teacher{
              id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
              telephone email availableTime socialMedia isSpecialTeacher
            }
            subject{
              id code nameLocal nameEng
            }
          }
          vdoSet{
            id code totalVdoLength
            vdoSetUnits {
              id unitSeq
              vdoSetTopics{
                id vdoStreamPath
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
          courseOutline{
            id
            courseOutlineUnits{ id }
          }
        }
        courseOutlineUnit { id seq nameLocal nameEng }
      }
    }
  }
`;

export const GET_VDOLIVESET_BY_LIVECLASSSCHEDULEID = gql`
  query getVdoLiveSetByLiveClassScheduleId($liveClassScheduleId : ID!){
    getVdoLiveSetByLiveClassScheduleId (
      liveClassScheduleId: $liveClassScheduleId
    ) {
      id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      liveClassSchedule{
        id periodCode degreeCode subjectGroupCode subjectCode subjectName
        teacherCode teacherFullName sectionNo topicLocal topicEng
        dateTimeFrom dateTimeTo liveFrom contract remark
        rtmpServer rtmpStream isEnabled
        academicPeriod { id periodCode }
        degree { id code nameLocal nameEng }
        subjectGroup { id code nameLocal nameEng }
        subject { id code nameLocal nameEng }
        teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
          telephone email socialMedia availableTime isSpecialTeacher picturePath label
        }
        courseOutlineRegistration  { id }
        classSection { id sectionNo descriptionLocal descriptionEng
          startClassDate learnSpanNo examSpanNo studentRegisterQty
          classRoom{
            id
            nameLocal
            nameEng
            studentRegisterQty
            capacity
            startDate
            endDate
            courseOutlineRegistration{
              id
              courseOutline {
                id courseOutlineUnits{
                  id seq nameLocal nameEng
                }
              }
            }
            degree{ id code }
            subjectGroup{ id code}
            classSection{
              id sectionNo descriptionLocal descriptionEng startClassDate
              learnSpanNo examSpanNo studentQty studentRegisterQty
            }
            teacher{
              id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
              telephone email availableTime socialMedia isSpecialTeacher
            }
            subject{
              id code nameLocal nameEng
            }
          }
          vdoSet{
            id code totalVdoLength
            vdoSetUnits {
              id unitSeq
              vdoSetTopics{
                id vdoStreamPath
                playbackUrl
                playbackStatus
                videoProvider
                bunnyVideoGuid
                bunnyStatus
              }
            }
          }
          courseOutline{
            id
            courseOutlineUnits{ id }
          }
        }
        courseOutlineUnit { id seq nameLocal nameEng }
      }
      vdoLiveSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath
      }
    }
  }
`;

export const GET_VDOLIVESETS_BY_FILTER = gql`

  query getVdoLiveSetsByFilter($vdoLiveSetFilterInput: VdoLiveSetFilterInput){
    getVdoLiveSetsByFilter (
      vdoLiveSetFilterInput:$vdoLiveSetFilterInput
    ){
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }

    }
  }
`;

export const GET_VDOLIVESETS = gql`
  query getVdoLiveSets {
    getVdoLiveSets {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const ADD_VDOLIVESET = gql`
  mutation addVdoLiveSet(
    $degreeId: ID
    $subjectGroupId: ID
    $subjectId: ID
    $teacherId: ID
    $academicPeriodId: ID
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $courseOutlineUnitId: ID
    $vdoLiveSetInput: VdoLiveSetInput!
  ) {
    addVdoLiveSet(
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      courseOutlineUnitId: $courseOutlineUnitId
      vdoLiveSetInput: $vdoLiveSetInput
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const UPDATE_VDOLIVESET = gql`
  mutation updateVdoLiveSet(
    $id: ID!,
    $degreeId: ID
    $subjectGroupId: ID
    $subjectId: ID
    $teacherId: ID
    $academicPeriodId: ID
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $courseOutlineUnitId: ID
    $vdoLiveSetInput: VdoLiveSetInput!
  ) {
    updateVdoLiveSet(
      id: $id
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      courseOutlineUnitId: $courseOutlineUnitId
      vdoLiveSetInput: $vdoLiveSetInput
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

export const DELETE_VDOLIVESET = gql`
  mutation deleteVdoLiveSet($id: ID!) {
    deleteVdoLiveSet(
      id: $id
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo liveFrom contract remark
      rtmpServer rtmpStream isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
      courseOutlineUnit { id seq nameLocal nameEng }
    }
  }
`;

